var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/map");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/instance/map", "./util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/instance/map"), require("./util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, _mapInstanceProperty2(global), global.util);
    global._try = mod.exports;
  }
})(this, function (_exports, _map, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.setting = setting;
  _exports.default = void 0;
  _map = _interopRequireDefault(_map);
  var tryJS = {};
  tryJS.wrap = wrap;
  tryJS.wrapArgs = tryifyArgs;
  var config = {
    handleTryCatchError: function handleTryCatchError() {}
  };

  function setting(opts) {
    (0, _util.merge)(opts, config);
  }

  function wrap(func) {
    return (0, _util.isFunction)(func) ? tryify(func) : func;
  }
  /**
   * 将函数使用 try..catch 包装
   *
   * @param  {Function} func 需要进行包装的函数
   * @return {Function} 包装后的函数
   */


  function tryify(func) {
    // 确保只包装一次
    if (!func._wrapped) {
      func._wrapped = function () {
        try {
          return func.apply(this, arguments);
        } catch (error) {
          config.handleTryCatchError(error);
          window.ignoreError = true;
          throw error;
        }
      };
    }

    return func._wrapped;
  }
  /**
   * 只对函数参数进行包装
   *
   * @param  {Function} func 需要进行包装的函数
   * @return {Function}
   */


  function tryifyArgs(func) {
    return function () {
      var _context;

      var args = (0, _map.default)(_context = (0, _util.arrayFrom)(arguments)).call(_context, function (arg) {
        return wrap(arg);
      });
      return func.apply(this, args);
    };
  }

  var _default = tryJS;
  _exports.default = _default;
});